<section>
  @defer(on viewport) {
  <header class="text-center mb-5">
    <h2 class="h3-responsive font-bold mb-5">ABOUT US</h2>
    <p class="text-gray-500 h5-responsive">Brief Description About Monisfer</p>
  </header>
  <div class="about mon-card">
    <a class="block h5-responsive text-gray-500" href="https://trustply.com/?utm_source=monisfer">
      <p>
        Monisfer currency exchange is a subsidiary of Trustply, a leading fintech company registered with Corporations Canada in 2017 under Canada Business Corporations
        Act with Corporation Number 1022339-5.
      </p>
      <p>As well as the above certification, Monisfer currency exchange has the MSB registration number M20715514 from Fintrac to conduct currency exchanges.</p>
      <p>
        Canadian companies dealing with foreign currencies must register with Fintrac (Financial Transactions and Reports Analysis Centre of Canada). To prevent money
        laundering and terrorism financing, these companies are required to keep records, report, and comply with other Fintrac requirements.
      </p>
    </a>
  </div>
  }@placeholder {
  <div class="spinner-center">
    <mat-spinner></mat-spinner>
  </div>
  }
</section>
